
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as loginyiubrZraL9EDD3J38Z_45ftLpCUym9OoYm1Hb9453rWnMMeta } from "/vercel/path0/pages/login.vue?macro=true";
import { default as organization_45qrTOHUCCt087rQYgbfiUxXp35Bf3CWbJL23Kdyi2RQoy4Meta } from "/vercel/path0/pages/btn-qr/organization-qr.vue?macro=true";
import { default as organization_45buttonXEeD4FtRYZwtDjKPIIk_aJq4JiWxHMiTeAORYHx3WLIMeta } from "/vercel/path0/pages/btn-qr/organization-button.vue?macro=true";
import { default as btn_45qrAZOUB_45ZTV024uF7VWSquQBE6rBUYYeSGSTTGpeNGeroMeta } from "/vercel/path0/pages/btn-qr.vue?macro=true";
import { default as registerYVQw2hrVHVB4lGWKPyo5FmqMHpKgdBVJqzomEM8zf3IMeta } from "/vercel/path0/pages/register.vue?macro=true";
import { default as _91type_93oQvqMiuw9tYLYifuOIKYHpA0U__452g53hgVT_EfOOz3gMeta } from "/vercel/path0/pages/settings/[type].vue?macro=true";
import { default as employees98E_45aXUMNJEJYbSnXow9JWDKyUrHUoyz3pklScjSOb0Meta } from "/vercel/path0/pages/settings/employees.vue?macro=true";
import { default as settings9Itu3riP9CqWX2opHgufCqw701YOBx4__ysuXBnjXKQMeta } from "/vercel/path0/pages/settings.vue?macro=true";
import { default as new_45passwordegKr25f7r20V9YucU1s0rCKYjpY5DZQAcjFqx4u6PSkMeta } from "/vercel/path0/pages/new-password.vue?macro=true";
import { default as indexIRxEShgtnhaJLfDwB3jHIhmBFsk9ex1fI3P1TaY_45uSkMeta } from "/vercel/path0/pages/support/index.vue?macro=true";
import { default as indexu6VUi26XJSPeygrbo1TLgQRYPQYEXunCoL_45tmff89dMMeta } from "/vercel/path0/pages/contacts/index.vue?macro=true";
import { default as indexCI1g87E8ZDzqBc4yZxPD3uyURhRkZqzX_452ctGEkHdtkMeta } from "/vercel/path0/pages/requests/index.vue?macro=true";
import { default as _91type_93hdWmi43AXB6mh0EJuAQU6qhxtAJUHDz_4Il5q5YAEWwMeta } from "/vercel/path0/pages/kalendar/[type].vue?macro=true";
import { default as createk_Lu15F1JpZJgFnP2Euq37kPJAt4Xr971ANguV1hyT0Meta } from "/vercel/path0/pages/requests/create.vue?macro=true";
import { default as indexkM_cc1PwIMCIJleyUDM6kJTPbA1lKMJ7sLFkdQV6ft8Meta } from "/vercel/path0/pages/admin/stats/index.vue?macro=true";
import { default as index7snL9UJ5WLMMYu9u6IIh5rvPHrHKNA_tpciPwCSJ9OEMeta } from "/vercel/path0/pages/admin/users/index.vue?macro=true";
import { default as _91type_93r_krCdkUPZj56CjbiLmrGacYru9sVYQW_454fahSHjlLgMeta } from "/vercel/path0/pages/operator/settings/[type].vue?macro=true";
import { default as settings7C8JOm85QC6YAb3oDFNe6CMB5KXan1k8cU31nKIgfv8Meta } from "/vercel/path0/pages/operator/settings.vue?macro=true";
import { default as indexF1fae3FrgsNZ_rjZYVZf4_mP4YjgHcimuq1FACl1WjAMeta } from "/vercel/path0/pages/admin/alerts/index.vue?macro=true";
import { default as _91id_93rIW8XZJf_45KonRUeWwIgrHeABFjymGSU7ubDo8IseYFgMeta } from "/vercel/path0/pages/admin/blocked/[id].vue?macro=true";
import { default as indexbtHXoNLzYhpsbaBahuFdzNCde3SIeyOZpsQTRFFPCJwMeta } from "/vercel/path0/pages/admin/shifts/index.vue?macro=true";
import { default as createuH_45kC9Zp0_wSoYRomsyP8b9UkBmBYad0Y9roNwxXeekMeta } from "/vercel/path0/pages/admin/users/create.vue?macro=true";
import { default as forgotten_45password5hPVXXVPA1gsbxFL9MX_45RkPixn05OrW2f2tN3ocU0v8Meta } from "/vercel/path0/pages/forgotten-password.vue?macro=true";
import { default as chat6lu_45tci3WDG22h3ZnudhX_HB6O1Yf_hS_45UhuJQRiDAkMeta } from "/vercel/path0/pages/requests/[id]/chat.vue?macro=true";
import { default as editt1tClaBv9qpnPXriudGg1BXeLk9K6M1Amxj3F9_45Q6moMeta } from "/vercel/path0/pages/requests/[id]/edit.vue?macro=true";
import { default as indexY3TG9_7sI_45hG0Ph_45n_bcRl3FkdldNXTYN8daTniacb4Meta } from "/vercel/path0/pages/admin/blocked/index.vue?macro=true";
import { default as indexBE_45owSlIH8_45GpGQP8C_7r15nyk_Hkx3tuWJSEDFbvu4Meta } from "/vercel/path0/pages/admin/ratings/index.vue?macro=true";
import { default as createkAww7ttoym182izQJPSjs2my44_45YkDkkpCvNtBBeEv0Meta } from "/vercel/path0/pages/admin/shifts/create.vue?macro=true";
import { default as indexAlHKNmTvatJj_45v5cbyiBzQ5M4cScH2d4Rl1NtreF1ucMeta } from "/vercel/path0/pages/operator/users/[id]/index.vue?macro=true";
import { default as historyenw2a01xFSfNj9P8aIoTgciKPBGIukM11_45mll3FRjssMeta } from "/vercel/path0/pages/operator/users/[id]/history.vue?macro=true";
import { default as _91id_93gmykVMEIM0mHuULnq8L4ije0rjGMIwBRpIvtlpo5rxgMeta } from "/vercel/path0/pages/operator/users/[id].vue?macro=true";
import { default as edit98g_45hzSUS27FGSSWkw0Ytj7Jlp1qIpslhGdxRlSHY9oMeta } from "/vercel/path0/pages/admin/users/[id]/edit.vue?macro=true";
import { default as indexDy_Oewfr_u86Vk7E6c65c5w3jTNx5yjobr_45K3AQK4jsMeta } from "/vercel/path0/pages/operator/shifts/index.vue?macro=true";
import { default as waitingN0vg5nIfObODu3kvVaK2oc_3m4QlUSiAZy7v5uzn2AAMeta } from "/vercel/path0/pages/requests/[id]/waiting.vue?macro=true";
import { default as indexeghQomcWfjxXShD40wchvYBv9hp4Ep932fNw_45thW8esMeta } from "/vercel/path0/pages/admin/activities/index.vue?macro=true";
import { default as edithJatL17I1I2C8CEJuLyt_457TexZX6fj1yXA4eOTtf9LUMeta } from "/vercel/path0/pages/admin/shifts/[id]/edit.vue?macro=true";
import { default as indexh4deMXDeQhZp4_a9LzXCO_tvvO1rnfqLnJRo5hc21nAMeta } from "/vercel/path0/pages/admin/users/[id]/index.vue?macro=true";
import { default as create_45sVqDuiu8ujT83vYggyYOts1S4sev2_45Q_45F_kKdGNYdsMeta } from "/vercel/path0/pages/operator/shifts/create.vue?macro=true";
import { default as clients5NkHSjvDO_45ryHAonkgtcO3z_3L4GXnmnU5p5wbkPxCoMeta } from "/vercel/path0/pages/operator/users/clients.vue?macro=true";
import { default as reservedzZUu3dxYqJ89dXfsk75ND0FhXqNUD5CXfUu2wJc_45yHMMeta } from "/vercel/path0/pages/requests/[id]/reserved.vue?macro=true";
import { default as indexWTMS3MJKCKRloNTqahKhMQdN3BxUcvpZan2SpE6OLm4Meta } from "/vercel/path0/pages/operator/requests/index.vue?macro=true";
import { default as operatorsj63l5j0XenLp6qRGKFqPaHkFgM3cfsbEcMm5TIdabboMeta } from "/vercel/path0/pages/operator/users/operators.vue?macro=true";
import { default as editO7uefZXOSf2lHHBhIqnpQFAEAxKPBTT8Aiz9jWIOFSYMeta } from "/vercel/path0/pages/operator/shifts/[id]/edit.vue?macro=true";
import { default as chatmRaGW19RX3AuBkv7BzoCPTDq4sKt_457gSIYxnEJxypfoMeta } from "/vercel/path0/pages/operator/requests/[id]/chat.vue?macro=true";
import { default as organizations_mVc60r3K_Ty3zSkkHAtmspZdw0Au1SscI4IFeN9oKMMeta } from "/vercel/path0/pages/operator/users/organizations.vue?macro=true";
import { default as indexTR1Zb_OUmKXzKfyA0mNESeO_45QxQSHG3yh0K4Q0IL6AoMeta } from "/vercel/path0/pages/operator/requests/[id]/detail/index.vue?macro=true";
import { default as client6PsiZLz75NLrpFl_k7pHVysPpwLrfxrL1XbyGbz9VfQMeta } from "/vercel/path0/pages/operator/requests/[id]/detail/client.vue?macro=true";
import { default as historyHx5ooaTCe4tGq7eOzOyKhuM3OyGkDgo6xhO0cfxkPqcMeta } from "/vercel/path0/pages/operator/requests/[id]/detail/history.vue?macro=true";
import { default as detailUvXVDkNl7cgx8M60ChxOaagG_45J2gGwKIIhf9mWhT_45SgMeta } from "/vercel/path0/pages/operator/requests/[id]/detail.vue?macro=true";
export default [
  {
    name: "index___cs",
    path: "/",
    meta: indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___ua",
    path: "/ua",
    meta: indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "login___cs",
    path: "/login",
    meta: loginyiubrZraL9EDD3J38Z_45ftLpCUym9OoYm1Hb9453rWnMMeta || {},
    component: () => import("/vercel/path0/pages/login.vue")
  },
  {
    name: "login___ua",
    path: "/ua/login",
    meta: loginyiubrZraL9EDD3J38Z_45ftLpCUym9OoYm1Hb9453rWnMMeta || {},
    component: () => import("/vercel/path0/pages/login.vue")
  },
  {
    name: "btn-qr___cs",
    path: "/btn-qr",
    meta: btn_45qrAZOUB_45ZTV024uF7VWSquQBE6rBUYYeSGSTTGpeNGeroMeta || {},
    component: () => import("/vercel/path0/pages/btn-qr.vue"),
    children: [
  {
    name: "btn-qr-organization-qr___cs",
    path: "organization-qr",
    meta: organization_45qrTOHUCCt087rQYgbfiUxXp35Bf3CWbJL23Kdyi2RQoy4Meta || {},
    component: () => import("/vercel/path0/pages/btn-qr/organization-qr.vue")
  },
  {
    name: "btn-qr-organization-button___cs",
    path: "organization-button",
    meta: organization_45buttonXEeD4FtRYZwtDjKPIIk_aJq4JiWxHMiTeAORYHx3WLIMeta || {},
    component: () => import("/vercel/path0/pages/btn-qr/organization-button.vue")
  }
]
  },
  {
    name: "btn-qr___ua",
    path: "/ua/btn-qr",
    meta: btn_45qrAZOUB_45ZTV024uF7VWSquQBE6rBUYYeSGSTTGpeNGeroMeta || {},
    component: () => import("/vercel/path0/pages/btn-qr.vue"),
    children: [
  {
    name: "btn-qr-organization-qr___ua",
    path: "organization-qr",
    meta: organization_45qrTOHUCCt087rQYgbfiUxXp35Bf3CWbJL23Kdyi2RQoy4Meta || {},
    component: () => import("/vercel/path0/pages/btn-qr/organization-qr.vue")
  },
  {
    name: "btn-qr-organization-button___ua",
    path: "organization-button",
    meta: organization_45buttonXEeD4FtRYZwtDjKPIIk_aJq4JiWxHMiTeAORYHx3WLIMeta || {},
    component: () => import("/vercel/path0/pages/btn-qr/organization-button.vue")
  }
]
  },
  {
    name: "register___cs",
    path: "/register",
    meta: registerYVQw2hrVHVB4lGWKPyo5FmqMHpKgdBVJqzomEM8zf3IMeta || {},
    component: () => import("/vercel/path0/pages/register.vue")
  },
  {
    name: "register___ua",
    path: "/ua/register",
    meta: registerYVQw2hrVHVB4lGWKPyo5FmqMHpKgdBVJqzomEM8zf3IMeta || {},
    component: () => import("/vercel/path0/pages/register.vue")
  },
  {
    name: "settings___cs",
    path: "/settings",
    meta: settings9Itu3riP9CqWX2opHgufCqw701YOBx4__ysuXBnjXKQMeta || {},
    component: () => import("/vercel/path0/pages/settings.vue"),
    children: [
  {
    name: "settings-type___cs",
    path: ":type()",
    meta: _91type_93oQvqMiuw9tYLYifuOIKYHpA0U__452g53hgVT_EfOOz3gMeta || {},
    component: () => import("/vercel/path0/pages/settings/[type].vue")
  },
  {
    name: "settings-employees___cs",
    path: "employees",
    meta: employees98E_45aXUMNJEJYbSnXow9JWDKyUrHUoyz3pklScjSOb0Meta || {},
    component: () => import("/vercel/path0/pages/settings/employees.vue")
  }
]
  },
  {
    name: "settings___ua",
    path: "/ua/settings",
    meta: settings9Itu3riP9CqWX2opHgufCqw701YOBx4__ysuXBnjXKQMeta || {},
    component: () => import("/vercel/path0/pages/settings.vue"),
    children: [
  {
    name: "settings-type___ua",
    path: ":type()",
    meta: _91type_93oQvqMiuw9tYLYifuOIKYHpA0U__452g53hgVT_EfOOz3gMeta || {},
    component: () => import("/vercel/path0/pages/settings/[type].vue")
  },
  {
    name: "settings-employees___ua",
    path: "employees",
    meta: employees98E_45aXUMNJEJYbSnXow9JWDKyUrHUoyz3pklScjSOb0Meta || {},
    component: () => import("/vercel/path0/pages/settings/employees.vue")
  }
]
  },
  {
    name: "new-password___cs",
    path: "/new-password",
    meta: new_45passwordegKr25f7r20V9YucU1s0rCKYjpY5DZQAcjFqx4u6PSkMeta || {},
    component: () => import("/vercel/path0/pages/new-password.vue")
  },
  {
    name: "new-password___ua",
    path: "/ua/new-password",
    meta: new_45passwordegKr25f7r20V9YucU1s0rCKYjpY5DZQAcjFqx4u6PSkMeta || {},
    component: () => import("/vercel/path0/pages/new-password.vue")
  },
  {
    name: "support___cs",
    path: "/support",
    meta: indexIRxEShgtnhaJLfDwB3jHIhmBFsk9ex1fI3P1TaY_45uSkMeta || {},
    component: () => import("/vercel/path0/pages/support/index.vue")
  },
  {
    name: "support___ua",
    path: "/ua/support",
    meta: indexIRxEShgtnhaJLfDwB3jHIhmBFsk9ex1fI3P1TaY_45uSkMeta || {},
    component: () => import("/vercel/path0/pages/support/index.vue")
  },
  {
    name: "contacts___cs",
    path: "/contacts",
    meta: indexu6VUi26XJSPeygrbo1TLgQRYPQYEXunCoL_45tmff89dMMeta || {},
    component: () => import("/vercel/path0/pages/contacts/index.vue")
  },
  {
    name: "contacts___ua",
    path: "/ua/contacts",
    meta: indexu6VUi26XJSPeygrbo1TLgQRYPQYEXunCoL_45tmff89dMMeta || {},
    component: () => import("/vercel/path0/pages/contacts/index.vue")
  },
  {
    name: "requests___cs",
    path: "/requests",
    meta: indexCI1g87E8ZDzqBc4yZxPD3uyURhRkZqzX_452ctGEkHdtkMeta || {},
    component: () => import("/vercel/path0/pages/requests/index.vue")
  },
  {
    name: "requests___ua",
    path: "/ua/requests",
    meta: indexCI1g87E8ZDzqBc4yZxPD3uyURhRkZqzX_452ctGEkHdtkMeta || {},
    component: () => import("/vercel/path0/pages/requests/index.vue")
  },
  {
    name: "kalendar-type___cs",
    path: "/kalendar/:type()",
    meta: _91type_93hdWmi43AXB6mh0EJuAQU6qhxtAJUHDz_4Il5q5YAEWwMeta || {},
    component: () => import("/vercel/path0/pages/kalendar/[type].vue")
  },
  {
    name: "kalendar-type___ua",
    path: "/ua/kalendar/:type()",
    meta: _91type_93hdWmi43AXB6mh0EJuAQU6qhxtAJUHDz_4Il5q5YAEWwMeta || {},
    component: () => import("/vercel/path0/pages/kalendar/[type].vue")
  },
  {
    name: "requests-create___cs",
    path: "/requests/create",
    meta: createk_Lu15F1JpZJgFnP2Euq37kPJAt4Xr971ANguV1hyT0Meta || {},
    component: () => import("/vercel/path0/pages/requests/create.vue")
  },
  {
    name: "requests-create___ua",
    path: "/ua/requests/create",
    meta: createk_Lu15F1JpZJgFnP2Euq37kPJAt4Xr971ANguV1hyT0Meta || {},
    component: () => import("/vercel/path0/pages/requests/create.vue")
  },
  {
    name: "admin-stats___cs",
    path: "/admin/stats",
    meta: indexkM_cc1PwIMCIJleyUDM6kJTPbA1lKMJ7sLFkdQV6ft8Meta || {},
    component: () => import("/vercel/path0/pages/admin/stats/index.vue")
  },
  {
    name: "admin-stats___ua",
    path: "/ua/admin/stats",
    meta: indexkM_cc1PwIMCIJleyUDM6kJTPbA1lKMJ7sLFkdQV6ft8Meta || {},
    component: () => import("/vercel/path0/pages/admin/stats/index.vue")
  },
  {
    name: "admin-users___cs",
    path: "/admin/users",
    meta: index7snL9UJ5WLMMYu9u6IIh5rvPHrHKNA_tpciPwCSJ9OEMeta || {},
    component: () => import("/vercel/path0/pages/admin/users/index.vue")
  },
  {
    name: "admin-users___ua",
    path: "/ua/admin/users",
    meta: index7snL9UJ5WLMMYu9u6IIh5rvPHrHKNA_tpciPwCSJ9OEMeta || {},
    component: () => import("/vercel/path0/pages/admin/users/index.vue")
  },
  {
    name: "operator-settings___cs",
    path: "/operator/settings",
    meta: settings7C8JOm85QC6YAb3oDFNe6CMB5KXan1k8cU31nKIgfv8Meta || {},
    component: () => import("/vercel/path0/pages/operator/settings.vue"),
    children: [
  {
    name: "operator-settings-type___cs",
    path: ":type()",
    meta: _91type_93r_krCdkUPZj56CjbiLmrGacYru9sVYQW_454fahSHjlLgMeta || {},
    component: () => import("/vercel/path0/pages/operator/settings/[type].vue")
  }
]
  },
  {
    name: "operator-settings___ua",
    path: "/ua/operator/settings",
    meta: settings7C8JOm85QC6YAb3oDFNe6CMB5KXan1k8cU31nKIgfv8Meta || {},
    component: () => import("/vercel/path0/pages/operator/settings.vue"),
    children: [
  {
    name: "operator-settings-type___ua",
    path: ":type()",
    meta: _91type_93r_krCdkUPZj56CjbiLmrGacYru9sVYQW_454fahSHjlLgMeta || {},
    component: () => import("/vercel/path0/pages/operator/settings/[type].vue")
  }
]
  },
  {
    name: "admin-alerts___cs",
    path: "/admin/alerts",
    meta: indexF1fae3FrgsNZ_rjZYVZf4_mP4YjgHcimuq1FACl1WjAMeta || {},
    component: () => import("/vercel/path0/pages/admin/alerts/index.vue")
  },
  {
    name: "admin-alerts___ua",
    path: "/ua/admin/alerts",
    meta: indexF1fae3FrgsNZ_rjZYVZf4_mP4YjgHcimuq1FACl1WjAMeta || {},
    component: () => import("/vercel/path0/pages/admin/alerts/index.vue")
  },
  {
    name: "admin-blocked-id___cs",
    path: "/admin/blocked/:id()",
    meta: _91id_93rIW8XZJf_45KonRUeWwIgrHeABFjymGSU7ubDo8IseYFgMeta || {},
    component: () => import("/vercel/path0/pages/admin/blocked/[id].vue")
  },
  {
    name: "admin-blocked-id___ua",
    path: "/ua/admin/blocked/:id()",
    meta: _91id_93rIW8XZJf_45KonRUeWwIgrHeABFjymGSU7ubDo8IseYFgMeta || {},
    component: () => import("/vercel/path0/pages/admin/blocked/[id].vue")
  },
  {
    name: "admin-shifts___cs",
    path: "/admin/shifts",
    meta: indexbtHXoNLzYhpsbaBahuFdzNCde3SIeyOZpsQTRFFPCJwMeta || {},
    component: () => import("/vercel/path0/pages/admin/shifts/index.vue")
  },
  {
    name: "admin-shifts___ua",
    path: "/ua/admin/shifts",
    meta: indexbtHXoNLzYhpsbaBahuFdzNCde3SIeyOZpsQTRFFPCJwMeta || {},
    component: () => import("/vercel/path0/pages/admin/shifts/index.vue")
  },
  {
    name: "admin-users-create___cs",
    path: "/admin/users/create",
    meta: createuH_45kC9Zp0_wSoYRomsyP8b9UkBmBYad0Y9roNwxXeekMeta || {},
    component: () => import("/vercel/path0/pages/admin/users/create.vue")
  },
  {
    name: "admin-users-create___ua",
    path: "/ua/admin/users/create",
    meta: createuH_45kC9Zp0_wSoYRomsyP8b9UkBmBYad0Y9roNwxXeekMeta || {},
    component: () => import("/vercel/path0/pages/admin/users/create.vue")
  },
  {
    name: "forgotten-password___cs",
    path: "/forgotten-password",
    meta: forgotten_45password5hPVXXVPA1gsbxFL9MX_45RkPixn05OrW2f2tN3ocU0v8Meta || {},
    component: () => import("/vercel/path0/pages/forgotten-password.vue")
  },
  {
    name: "forgotten-password___ua",
    path: "/ua/forgotten-password",
    meta: forgotten_45password5hPVXXVPA1gsbxFL9MX_45RkPixn05OrW2f2tN3ocU0v8Meta || {},
    component: () => import("/vercel/path0/pages/forgotten-password.vue")
  },
  {
    name: "requests-id-chat___cs",
    path: "/requests/:id()/chat",
    meta: chat6lu_45tci3WDG22h3ZnudhX_HB6O1Yf_hS_45UhuJQRiDAkMeta || {},
    component: () => import("/vercel/path0/pages/requests/[id]/chat.vue")
  },
  {
    name: "requests-id-chat___ua",
    path: "/ua/requests/:id()/chat",
    meta: chat6lu_45tci3WDG22h3ZnudhX_HB6O1Yf_hS_45UhuJQRiDAkMeta || {},
    component: () => import("/vercel/path0/pages/requests/[id]/chat.vue")
  },
  {
    name: "requests-id-edit___cs",
    path: "/requests/:id()/edit",
    meta: editt1tClaBv9qpnPXriudGg1BXeLk9K6M1Amxj3F9_45Q6moMeta || {},
    component: () => import("/vercel/path0/pages/requests/[id]/edit.vue")
  },
  {
    name: "requests-id-edit___ua",
    path: "/ua/requests/:id()/edit",
    meta: editt1tClaBv9qpnPXriudGg1BXeLk9K6M1Amxj3F9_45Q6moMeta || {},
    component: () => import("/vercel/path0/pages/requests/[id]/edit.vue")
  },
  {
    name: "admin-blocked___cs",
    path: "/admin/blocked",
    meta: indexY3TG9_7sI_45hG0Ph_45n_bcRl3FkdldNXTYN8daTniacb4Meta || {},
    component: () => import("/vercel/path0/pages/admin/blocked/index.vue")
  },
  {
    name: "admin-blocked___ua",
    path: "/ua/admin/blocked",
    meta: indexY3TG9_7sI_45hG0Ph_45n_bcRl3FkdldNXTYN8daTniacb4Meta || {},
    component: () => import("/vercel/path0/pages/admin/blocked/index.vue")
  },
  {
    name: "admin-ratings___cs",
    path: "/admin/ratings",
    meta: indexBE_45owSlIH8_45GpGQP8C_7r15nyk_Hkx3tuWJSEDFbvu4Meta || {},
    component: () => import("/vercel/path0/pages/admin/ratings/index.vue")
  },
  {
    name: "admin-ratings___ua",
    path: "/ua/admin/ratings",
    meta: indexBE_45owSlIH8_45GpGQP8C_7r15nyk_Hkx3tuWJSEDFbvu4Meta || {},
    component: () => import("/vercel/path0/pages/admin/ratings/index.vue")
  },
  {
    name: "admin-shifts-create___cs",
    path: "/admin/shifts/create",
    meta: createkAww7ttoym182izQJPSjs2my44_45YkDkkpCvNtBBeEv0Meta || {},
    component: () => import("/vercel/path0/pages/admin/shifts/create.vue")
  },
  {
    name: "admin-shifts-create___ua",
    path: "/ua/admin/shifts/create",
    meta: createkAww7ttoym182izQJPSjs2my44_45YkDkkpCvNtBBeEv0Meta || {},
    component: () => import("/vercel/path0/pages/admin/shifts/create.vue")
  },
  {
    name: _91id_93gmykVMEIM0mHuULnq8L4ije0rjGMIwBRpIvtlpo5rxgMeta?.name,
    path: "/operator/users/:id()",
    meta: _91id_93gmykVMEIM0mHuULnq8L4ije0rjGMIwBRpIvtlpo5rxgMeta || {},
    component: () => import("/vercel/path0/pages/operator/users/[id].vue"),
    children: [
  {
    name: "operator-users-id___cs",
    path: "",
    component: () => import("/vercel/path0/pages/operator/users/[id]/index.vue")
  },
  {
    name: "operator-users-id-history___cs",
    path: "history",
    meta: historyenw2a01xFSfNj9P8aIoTgciKPBGIukM11_45mll3FRjssMeta || {},
    component: () => import("/vercel/path0/pages/operator/users/[id]/history.vue")
  }
]
  },
  {
    name: _91id_93gmykVMEIM0mHuULnq8L4ije0rjGMIwBRpIvtlpo5rxgMeta?.name,
    path: "/ua/operator/users/:id()",
    meta: _91id_93gmykVMEIM0mHuULnq8L4ije0rjGMIwBRpIvtlpo5rxgMeta || {},
    component: () => import("/vercel/path0/pages/operator/users/[id].vue"),
    children: [
  {
    name: "operator-users-id___ua",
    path: "",
    component: () => import("/vercel/path0/pages/operator/users/[id]/index.vue")
  },
  {
    name: "operator-users-id-history___ua",
    path: "history",
    meta: historyenw2a01xFSfNj9P8aIoTgciKPBGIukM11_45mll3FRjssMeta || {},
    component: () => import("/vercel/path0/pages/operator/users/[id]/history.vue")
  }
]
  },
  {
    name: "admin-users-id-edit___cs",
    path: "/admin/users/:id()/edit",
    meta: edit98g_45hzSUS27FGSSWkw0Ytj7Jlp1qIpslhGdxRlSHY9oMeta || {},
    component: () => import("/vercel/path0/pages/admin/users/[id]/edit.vue")
  },
  {
    name: "admin-users-id-edit___ua",
    path: "/ua/admin/users/:id()/edit",
    meta: edit98g_45hzSUS27FGSSWkw0Ytj7Jlp1qIpslhGdxRlSHY9oMeta || {},
    component: () => import("/vercel/path0/pages/admin/users/[id]/edit.vue")
  },
  {
    name: "operator-shifts___cs",
    path: "/operator/shifts",
    meta: indexDy_Oewfr_u86Vk7E6c65c5w3jTNx5yjobr_45K3AQK4jsMeta || {},
    component: () => import("/vercel/path0/pages/operator/shifts/index.vue")
  },
  {
    name: "operator-shifts___ua",
    path: "/ua/operator/shifts",
    meta: indexDy_Oewfr_u86Vk7E6c65c5w3jTNx5yjobr_45K3AQK4jsMeta || {},
    component: () => import("/vercel/path0/pages/operator/shifts/index.vue")
  },
  {
    name: "requests-id-waiting___cs",
    path: "/requests/:id()/waiting",
    meta: waitingN0vg5nIfObODu3kvVaK2oc_3m4QlUSiAZy7v5uzn2AAMeta || {},
    component: () => import("/vercel/path0/pages/requests/[id]/waiting.vue")
  },
  {
    name: "requests-id-waiting___ua",
    path: "/ua/requests/:id()/waiting",
    meta: waitingN0vg5nIfObODu3kvVaK2oc_3m4QlUSiAZy7v5uzn2AAMeta || {},
    component: () => import("/vercel/path0/pages/requests/[id]/waiting.vue")
  },
  {
    name: "admin-activities___cs",
    path: "/admin/activities",
    meta: indexeghQomcWfjxXShD40wchvYBv9hp4Ep932fNw_45thW8esMeta || {},
    component: () => import("/vercel/path0/pages/admin/activities/index.vue")
  },
  {
    name: "admin-activities___ua",
    path: "/ua/admin/activities",
    meta: indexeghQomcWfjxXShD40wchvYBv9hp4Ep932fNw_45thW8esMeta || {},
    component: () => import("/vercel/path0/pages/admin/activities/index.vue")
  },
  {
    name: "admin-shifts-id-edit___cs",
    path: "/admin/shifts/:id()/edit",
    meta: edithJatL17I1I2C8CEJuLyt_457TexZX6fj1yXA4eOTtf9LUMeta || {},
    component: () => import("/vercel/path0/pages/admin/shifts/[id]/edit.vue")
  },
  {
    name: "admin-shifts-id-edit___ua",
    path: "/ua/admin/shifts/:id()/edit",
    meta: edithJatL17I1I2C8CEJuLyt_457TexZX6fj1yXA4eOTtf9LUMeta || {},
    component: () => import("/vercel/path0/pages/admin/shifts/[id]/edit.vue")
  },
  {
    name: "admin-users-id___cs",
    path: "/admin/users/:id()",
    meta: indexh4deMXDeQhZp4_a9LzXCO_tvvO1rnfqLnJRo5hc21nAMeta || {},
    component: () => import("/vercel/path0/pages/admin/users/[id]/index.vue")
  },
  {
    name: "admin-users-id___ua",
    path: "/ua/admin/users/:id()",
    meta: indexh4deMXDeQhZp4_a9LzXCO_tvvO1rnfqLnJRo5hc21nAMeta || {},
    component: () => import("/vercel/path0/pages/admin/users/[id]/index.vue")
  },
  {
    name: "operator-shifts-create___cs",
    path: "/operator/shifts/create",
    meta: create_45sVqDuiu8ujT83vYggyYOts1S4sev2_45Q_45F_kKdGNYdsMeta || {},
    component: () => import("/vercel/path0/pages/operator/shifts/create.vue")
  },
  {
    name: "operator-shifts-create___ua",
    path: "/ua/operator/shifts/create",
    meta: create_45sVqDuiu8ujT83vYggyYOts1S4sev2_45Q_45F_kKdGNYdsMeta || {},
    component: () => import("/vercel/path0/pages/operator/shifts/create.vue")
  },
  {
    name: "operator-users-clients___cs",
    path: "/operator/users/clients",
    meta: clients5NkHSjvDO_45ryHAonkgtcO3z_3L4GXnmnU5p5wbkPxCoMeta || {},
    component: () => import("/vercel/path0/pages/operator/users/clients.vue")
  },
  {
    name: "operator-users-clients___ua",
    path: "/ua/operator/users/clients",
    meta: clients5NkHSjvDO_45ryHAonkgtcO3z_3L4GXnmnU5p5wbkPxCoMeta || {},
    component: () => import("/vercel/path0/pages/operator/users/clients.vue")
  },
  {
    name: "requests-id-reserved___cs",
    path: "/requests/:id()/reserved",
    meta: reservedzZUu3dxYqJ89dXfsk75ND0FhXqNUD5CXfUu2wJc_45yHMMeta || {},
    component: () => import("/vercel/path0/pages/requests/[id]/reserved.vue")
  },
  {
    name: "requests-id-reserved___ua",
    path: "/ua/requests/:id()/reserved",
    meta: reservedzZUu3dxYqJ89dXfsk75ND0FhXqNUD5CXfUu2wJc_45yHMMeta || {},
    component: () => import("/vercel/path0/pages/requests/[id]/reserved.vue")
  },
  {
    name: "operator-requests___cs",
    path: "/operator/requests",
    meta: indexWTMS3MJKCKRloNTqahKhMQdN3BxUcvpZan2SpE6OLm4Meta || {},
    component: () => import("/vercel/path0/pages/operator/requests/index.vue")
  },
  {
    name: "operator-requests___ua",
    path: "/ua/operator/requests",
    meta: indexWTMS3MJKCKRloNTqahKhMQdN3BxUcvpZan2SpE6OLm4Meta || {},
    component: () => import("/vercel/path0/pages/operator/requests/index.vue")
  },
  {
    name: "operator-users-operators___cs",
    path: "/operator/users/operators",
    meta: operatorsj63l5j0XenLp6qRGKFqPaHkFgM3cfsbEcMm5TIdabboMeta || {},
    component: () => import("/vercel/path0/pages/operator/users/operators.vue")
  },
  {
    name: "operator-users-operators___ua",
    path: "/ua/operator/users/operators",
    meta: operatorsj63l5j0XenLp6qRGKFqPaHkFgM3cfsbEcMm5TIdabboMeta || {},
    component: () => import("/vercel/path0/pages/operator/users/operators.vue")
  },
  {
    name: "operator-shifts-id-edit___cs",
    path: "/operator/shifts/:id()/edit",
    meta: editO7uefZXOSf2lHHBhIqnpQFAEAxKPBTT8Aiz9jWIOFSYMeta || {},
    component: () => import("/vercel/path0/pages/operator/shifts/[id]/edit.vue")
  },
  {
    name: "operator-shifts-id-edit___ua",
    path: "/ua/operator/shifts/:id()/edit",
    meta: editO7uefZXOSf2lHHBhIqnpQFAEAxKPBTT8Aiz9jWIOFSYMeta || {},
    component: () => import("/vercel/path0/pages/operator/shifts/[id]/edit.vue")
  },
  {
    name: "operator-requests-id-chat___cs",
    path: "/operator/requests/:id()/chat",
    meta: chatmRaGW19RX3AuBkv7BzoCPTDq4sKt_457gSIYxnEJxypfoMeta || {},
    component: () => import("/vercel/path0/pages/operator/requests/[id]/chat.vue")
  },
  {
    name: "operator-requests-id-chat___ua",
    path: "/ua/operator/requests/:id()/chat",
    meta: chatmRaGW19RX3AuBkv7BzoCPTDq4sKt_457gSIYxnEJxypfoMeta || {},
    component: () => import("/vercel/path0/pages/operator/requests/[id]/chat.vue")
  },
  {
    name: "operator-users-organizations___cs",
    path: "/operator/users/organizations",
    meta: organizations_mVc60r3K_Ty3zSkkHAtmspZdw0Au1SscI4IFeN9oKMMeta || {},
    component: () => import("/vercel/path0/pages/operator/users/organizations.vue")
  },
  {
    name: "operator-users-organizations___ua",
    path: "/ua/operator/users/organizations",
    meta: organizations_mVc60r3K_Ty3zSkkHAtmspZdw0Au1SscI4IFeN9oKMMeta || {},
    component: () => import("/vercel/path0/pages/operator/users/organizations.vue")
  },
  {
    name: detailUvXVDkNl7cgx8M60ChxOaagG_45J2gGwKIIhf9mWhT_45SgMeta?.name,
    path: "/operator/requests/:id()/detail",
    meta: detailUvXVDkNl7cgx8M60ChxOaagG_45J2gGwKIIhf9mWhT_45SgMeta || {},
    component: () => import("/vercel/path0/pages/operator/requests/[id]/detail.vue"),
    children: [
  {
    name: "operator-requests-id-detail___cs",
    path: "",
    component: () => import("/vercel/path0/pages/operator/requests/[id]/detail/index.vue")
  },
  {
    name: "operator-requests-id-detail-client___cs",
    path: "client",
    component: () => import("/vercel/path0/pages/operator/requests/[id]/detail/client.vue")
  },
  {
    name: "operator-requests-id-detail-history___cs",
    path: "history",
    meta: historyHx5ooaTCe4tGq7eOzOyKhuM3OyGkDgo6xhO0cfxkPqcMeta || {},
    component: () => import("/vercel/path0/pages/operator/requests/[id]/detail/history.vue")
  }
]
  },
  {
    name: detailUvXVDkNl7cgx8M60ChxOaagG_45J2gGwKIIhf9mWhT_45SgMeta?.name,
    path: "/ua/operator/requests/:id()/detail",
    meta: detailUvXVDkNl7cgx8M60ChxOaagG_45J2gGwKIIhf9mWhT_45SgMeta || {},
    component: () => import("/vercel/path0/pages/operator/requests/[id]/detail.vue"),
    children: [
  {
    name: "operator-requests-id-detail___ua",
    path: "",
    component: () => import("/vercel/path0/pages/operator/requests/[id]/detail/index.vue")
  },
  {
    name: "operator-requests-id-detail-client___ua",
    path: "client",
    component: () => import("/vercel/path0/pages/operator/requests/[id]/detail/client.vue")
  },
  {
    name: "operator-requests-id-detail-history___ua",
    path: "history",
    meta: historyHx5ooaTCe4tGq7eOzOyKhuM3OyGkDgo6xhO0cfxkPqcMeta || {},
    component: () => import("/vercel/path0/pages/operator/requests/[id]/detail/history.vue")
  }
]
  }
]